
import React from 'react';
import { Book, X } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useAppStore } from '@/store';
import { useKnowledgeBases } from '@/hooks/useKnowledgeBases';

interface KnowledgeBaseActiveIndicatorProps {
  knowledgeBaseName: string | null;
  onClear: () => void;
}

const KnowledgeBaseActiveIndicator: React.FC<KnowledgeBaseActiveIndicatorProps> = ({
  knowledgeBaseName,
  onClear
}) => {
  if (!knowledgeBaseName) return null;

  const { knowledgeBases, fetchKnowledgeBases } = useKnowledgeBases();

  React.useEffect(() => {
    fetchKnowledgeBases();
  }, [fetchKnowledgeBases]);

  const getKnowledgeBaseName = (kbId: string) => {
    const kb = knowledgeBases.find(kb => kb.id === kbId);
    return kb?.name || 'Unknown Knowledge Base';
  };
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="outline" 
            className="flex items-center gap-1.5 px-3 py-1 text-sm bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-300 border-purple-200 dark:border-purple-800"
          >
            <Book size={14} className="text-purple-700 dark:text-purple-400" />
            <span>{knowledgeBaseName}</span>
            <Button
              variant="ghost"
              size="icon"
              className="h-4 w-4 ml-1 p-0 hover:bg-purple-200 dark:hover:bg-purple-800 rounded-full"
              onClick={(e) => {
                e.stopPropagation();
                onClear();
              }}
            >
              <X size={12} />
            </Button>
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>Knowledge base active - click X to remove</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default KnowledgeBaseActiveIndicator;
